/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Chat_Work_Plan_ProgressInputs */



/**
* | output |
* | --- |
* | "{done}/{total}" |
*
* @param {Chat_Work_Plan_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_work_plan_progress = /** @type {((inputs: Chat_Work_Plan_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Work_Plan_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.done}/${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.done}/${i?.total}`)
});